module.exports = __webpack_public_path__ + "media/images/sport--ski_alpin-6bf8775b67f9e29480d70321752c30bb.png";